



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Route} from 'vue-router';
import {Form as ElForm, Input} from 'element-ui';

import AdUserInitAdminPopup from './ad-user-init-admin.vue';

import AuthService from '@/services/auth_service';
import { AppModule } from '@/store/modules/app';
import NotifyService from '@/services/notify_service';
import EcoObjectsService from "@/services/eco-objects-service";
import DictsCacheService from '@/services/dicts_cache_service';
import UserAccessService from '@/services/user_access_service';
import PresetService from '@/services/user_preset_service';
import YearService from '@/services/years-service';
import UserManagerService, { AdUserEntity } from '@/services/data/user_manager';
import ShareService from '@/services/share-service';
import MonitoringService from "@/views/admin/monitoring/service";

@Component({
  name: 'Login',
  components: {
    AdUserInitAdminPopup
  }
})
export default class extends Vue {

  public authSevice = AuthService;
  private notifyService = NotifyService;

  // Флаг перехода на страницу инициализации Администратора при первоначальной становке
  private isInitAdmin: boolean = false;
  private showAdSelectionDialog: boolean = false;
  private adUsers: AdUserEntity[] = [];

  private validateUsername = (rule: any, value: string, callback: Function) => {
    callback()
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    callback()
  }
  private loginForm = {
    username: '',
    password: ''
  }
  private loginRules = {
    username: [{validator: this.validateUsername, trigger: 'blur'}],
    password: [{validator: this.validatePassword, trigger: 'blur'}]
  }
  private passwordType = 'password'
  private loading = false
  private showDialog = false
  private redirect?: string

  @Watch('$route', {immediate: true})
  private onRouteChange(route: Route, routePrev: Route) {
    // Если предыдущее значение пути было не нулевое, значит хук mounted не отработает и надо инициализировать страницу
    if (routePrev) {
      this.initLoginPage();
    }

  }

  get isADAuth(): boolean {
    return AuthService.isActiveDirectoryAuth()
  }

  mounted() {
    this.initLoginPage();
  }

  private initLoginPage() {

    this.isInitAdmin = this.$route.name === 'init_admin';
    this.notifyService.isHandling401 = false;
    if (this.loginForm.username === '') {
      (this.$refs.username as Input).focus()
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus()
    }

    if (this.isADAuth && this.isInitAdmin) {
      this.initAdmin();
    } else if (this.isADAuth) {
      AppModule.SetAdLogin(true);
      this.loginForm = { password: "pass", username: "login" }
      this.handleLogin().finally(() => {
        AppModule.SetAdLogin(false);
      });
    }

  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }

  // Инициализация первоначального пользователя
  async initAdmin() {
    let initAdminResp = await this.authSevice.initAdminCheck();
    if (initAdminResp.length) {
      this.adUsers = [ ...initAdminResp ];
      this.showAdSelectionDialog = true;
    } else {
      this.notifyService.error('Не удалось получить список пользователей Active Directory')
    }
  }

  async handleLogin() {

    (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true;
          const requestData: { [key: string]: string | null } = {
            login: this.loginForm.username,
            password: this.loginForm.password,
            login_instead_of: null
          };
          let resp: any = await this.authSevice.login(requestData, this.isADAuth ? 900000 : undefined);

          if (resp.data) {
            this.authSevice.saveUserToken(resp.data);
            console.log('after finished');

            await ShareService.loadAllCaches();

            await this.$router.push('/home');



          } else {
            throw new Error('Не получен токен');
          }

        } catch (e) {
          return false;

        } finally {

          this.loading = false;
        }

      } else {
        return false;

      }
    })
  }

  async handleADLogin() {
    try {
      this.loading = true;
      const requestData = { ad_login: true, login: ""};
      let resp = await this.authSevice.loginAD(requestData, 900000);
      if (resp.data) {
        this.authSevice.saveUserToken(resp.data);
        await ShareService.loadAllCaches();
        await this.$router.push('/home');
      } else {
        throw new Error('Не получен токен');
      }
    } catch (e) {
      // Можно добавить обработку ошибок
    } finally {
      this.loading = false;
    }
  }

  private initAdminAdAccount(ad_guid: string) {
    if (ad_guid) {
      this.loading = true;
      this.authSevice.initAdminConfirm({ ad_guid }).then(() => {
        this.$router.push(`/login`).then(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.loading = false;
      });
    }
  }

}
